export enum PlaybackControlVariant {
  Delete,
  Play,
  Stop,
}
